module.exports = __webpack_public_path__ + "img/jxtitle.b65fee97.png";